import React, { useState, useEffect } from 'react';
import { X, Package } from 'lucide-react';
import './TipoCajaModal.css';

const TipoCajaModal = ({ isOpen, onClose, onSave, tipoCaja }) => {
  const [formData, setFormData] = useState({
    tipo: '',
    descripcion: '',
    activo: true
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (tipoCaja) {
      setFormData({
        tipo: tipoCaja.tipo || '',
        descripcion: tipoCaja.descripcion || '',
        activo: tipoCaja.activo !== undefined ? tipoCaja.activo : true
      });
    } else {
      setFormData({
        tipo: '',
        descripcion: '',
        activo: true
      });
    }
    setErrors({});
  }, [tipoCaja, isOpen]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.tipo.trim()) {
      newErrors.tipo = 'El tipo es requerido';
    } else if (formData.tipo.length > 10) {
      newErrors.tipo = 'El tipo no puede exceder 10 caracteres';
    }

    if (!formData.descripcion.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    } else if (formData.descripcion.length > 100) {
      newErrors.descripcion = 'La descripción no puede exceder 100 caracteres';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      onSave(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpiar error del campo al escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content tipo-caja-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-header-title">
            <Package size={24} />
            <h2>{tipoCaja ? 'Editar Tipo de Caja' : 'Nuevo Tipo de Caja'}</h2>
          </div>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="tipo">
                Tipo <span className="required">*</span>
              </label>
              <input
                type="text"
                id="tipo"
                name="tipo"
                value={formData.tipo}
                onChange={handleChange}
                placeholder="Ej: M, Q, P"
                className={errors.tipo ? 'error' : ''}
                maxLength={10}
                disabled={!!tipoCaja}
              />
              {errors.tipo && <span className="error-message">{errors.tipo}</span>}
              <small className="form-help">Código corto del tipo de caja (máx. 10 caracteres)</small>
            </div>

            <div className="form-group">
              <label htmlFor="descripcion">
                Descripción <span className="required">*</span>
              </label>
              <input
                type="text"
                id="descripcion"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                placeholder="Ej: Media, Quarter, Pequeña"
                className={errors.descripcion ? 'error' : ''}
                maxLength={100}
              />
              {errors.descripcion && <span className="error-message">{errors.descripcion}</span>}
              <small className="form-help">Descripción completa del tipo de caja (máx. 100 caracteres)</small>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="activo"
                  checked={formData.activo}
                  onChange={handleChange}
                />
                <span>Activo</span>
              </label>
              <small className="form-help">Los tipos inactivos no estarán disponibles para nuevos productos</small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {tipoCaja ? 'Guardar Cambios' : 'Crear Tipo de Caja'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TipoCajaModal;
